import { withInstall } from '../utils/index';
import Dialog from './index.vue';
import './index.less';

export const TlbsDialog = withInstall(Dialog);
export default TlbsDialog;
